/**
 * RealizationsScreen — adaptateur primaire de la route `realizations` en mode parent.
 *
 * Fil : `useRealizationsData` (les pages, filtrées par la recherche) + `realizationsViewModel`
 * (la liste) + `useRealizationsState` (la fermeture, la recherche) → `<RealizationsPage>`.
 *
 * La fiche d'une activité est celle du design system (`useActivityDetailsFlow`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { RealizationsPage } from "../../../../../../design-system"
import { realizationsViewModel } from "../../../../view-models/parent/Activities/realizationsViewModel"
import { useActivityDetailsFlow } from "../../../hooks/useActivityDetailsFlow"
import { useFinishedActivitiesParams } from "../../../hooks/useFinishedActivitiesParams"
import { ActivityOverlays } from "./ActivityOverlays"
import { useRealizationsData } from "./useRealizationsData"
import { useRealizationsState } from "./useRealizationsState"

export type RealizationsScreenProps = {
    route?: { params?: { studentId?: string | number } | null } | null
}

export function RealizationsScreen(props: RealizationsScreenProps) {
    const studentId = props.route?.params?.studentId ?? null
    const { search, actions } = useRealizationsState()
    const { refresh, loadMore, hasMore } = useRealizationsData(studentId, useFinishedActivitiesParams(search))
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((state: any) => realizationsViewModel(state, studentId))
    const details = useActivityDetailsFlow({ studentId, onChanged: refresh })

    return (
        <>
            <RealizationsPage
                activities={vm.activities}
                search={search}
                onSearchChange={actions.setSearch}
                searchSubjects={vm.searchSubjects}
                searchResultCount={vm.total}
                loading={vm.loading}
                refreshing={vm.refreshing}
                loadingMore={vm.loadingMore}
                hasMore={hasMore}
                error={vm.error}
                onRetry={refresh}
                onRefresh={refresh}
                onLoadMore={loadMore}
                onClose={actions.close}
                onOpenActivity={details.open}
            />
            <ActivityOverlays details={details.details} notice={details.notice} />
        </>
    )
}

export default RealizationsScreen
